import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-col-id", "onMousedown", "onClick"]
const _hoisted_2 = {
  key: 0,
  class: "qtl-multi"
}
const _hoisted_3 = { class: "qtl-row-num" }
const _hoisted_4 = ["disabled", "aria-label"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = { class: "qtl-del-confirm" }
const _hoisted_9 = { class: "qtl-del-confirm__text" }
const _hoisted_10 = { class: "qtl-del-confirm__actions" }

import { computed, ref } from "vue";
import MostaCheckbox from "@/components/common/basic/MostaCheckbox.vue";
import MostaContextMenu from "@/components/common/basic/MostaContextMenu.vue";
import SimpleCellElementLite from "../cell-items-lite/SimpleCellElementLite.vue";
import ChangeDateCellElementLite from "../cell-items-lite/ChangeDateCellElementLite.vue";
import BillCellElementLite from "../cell-items-lite/BillCellElementLite.vue";
import CommonCellElementLite from "../cell-items-lite/CommonCellElementLite.vue";
import EntityCellElementLite from "../cell-items-lite/EntityCellElementLite.vue";
import JobCellElementLite from "../cell-items-lite/JobCellElementLite.vue";
import TagCellElementLite from "../cell-items-lite/TagCellElementLite.vue";
import ParameterCellElementLite from "../cell-items-lite/ParameterCellElementLite.vue";
import TagNameCellElementLite from "../cell-items-lite/TagNameCellElementLite.vue";
import VendorCodeCellElementLite from "../cell-items-lite/VendorCodeCellElementLite.vue";
import NotesCellElementLite from "../cell-items-lite/NotesCellElementLite.vue";
import MinimizedCellLite from "../cell-items-lite/MinimizedCellLite.vue";
import SourceItemsCellElementLite from "../cell-items-lite/SourceItemsCellElementLite.vue";

import type { TableDataCell } from "@/models/interfaces/entity-settings/querytable/querytable";
import {
  AnalyticsV2ElementType,
  ColumnCategory,
  TableDataCellDisplayType,
} from "@/models/etc/types";
import { generalStore } from "@/store/general";
import { storageStore } from "@/store/storage/storage-instances";
import { storagePositionsStore } from "@/store/storage/storage-positions";
import { formatIconHtml } from "../cell-items-lite/cellFormat";
import type { LiteColumn, LiteRow } from "../types";
import { isCommentColumn } from "../commentColumn";


export default /*@__PURE__*/_defineComponent({
  __name: 'QTLiteRowCells',
  props: {
    row: {},
    columns: {},
    srcElement: {},
    WA: { type: Boolean },
    isChecked: { type: Boolean },
    rowIndex: {},
    rowNumberBase: {}
  },
  emits: ["toggleCheckbox", "changeHoverRecord", "changeHeights", "refreshNeeded", "updatePerson", "updateSelection", "checkBoxClick", "sourceItemsRequested"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const gstore = generalStore();
const storage = storageStore();
const storagePos = storagePositionsStore();
const hoveredParamRecId = ref<string | number | undefined>(undefined);
const canEditPerson = !!props.WA && gstore.selectedItem?.DestType === AnalyticsV2ElementType.Person;

// Урна удаления позиции показывается только в выборке по складским позициям
// (единообразно с canEditPerson по DestType). Активность гейтим правом записи в склад.
const isStoragePositions = computed(
  () => gstore.selectedItem?.DestType === AnalyticsV2ElementType.StorageItem,
);
const storageWA = computed(() => !!storage.storageAccess?.CanWrite);

const deleteConfirmOpen = ref(false);
const deleteMenuPos = ref<{ top: string; left: string }>({ top: "0px", left: "0px" });

function openDeleteConfirm(ev: MouseEvent) {
  if (!storageWA.value) return;
  const btn = ev.currentTarget as HTMLElement | null;
  const rect = btn?.getBoundingClientRect();
  if (rect) {
    deleteMenuPos.value = { top: `${rect.bottom + 2}px`, left: `${rect.left}px` };
  } else {
    deleteMenuPos.value = { top: `${ev.clientY}px`, left: `${ev.clientX}px` };
  }
  deleteConfirmOpen.value = true;
}

function confirmDelete() {
  // Строка убирается из таблицы внутри стора через queryStore().stripTableRows.
  if (props.row.entityId) storagePos.deleteStorageItem(props.row.entityId);
  deleteConfirmOpen.value = false;
}

function onCellHoverRecord(payload: { recId: any; rowNum: number }) {
  hoveredParamRecId.value = payload?.recId;
  emit("changeHoverRecord", payload);
}

function cellClass(col: LiteColumn) {
  return {
    "qtl-cell": true,
    "qtl-cell--multiedit": !!col.isMultiedit,
    "qtl-cell--note": isNoteColumn(col),
    "qtl-col-comment": isCommentColumn(col),
  };
}

// У ячейки комментария свои отступы внутри NativeInput, а клик по ней включает правку,
// поэтому padding самой td снимаем, чтобы кликабельной была вся площадь.
function isNoteColumn(col: LiteColumn): boolean {
  if (col.isMultiedit) return false;
  const cell = props.row.cells[col.id];
  if (!cell || !cell.subItems) return false;
  return cell.subItems.some((s) => isNote(s) || isTableComment(s));
}

function onToggleCheckbox(val: boolean) {
  emit("toggleCheckbox", { entityId: props.row.entityId, checked: val });
}

// Клик по всей ячейке галочек переключает выбор строки. Сам чекбокс и урна удаления
// с @click.stop, поэтому двойного срабатывания нет.
function onMultieditCellClick(col: LiteColumn) {
  if (!col.isMultiedit) return;
  emit("toggleCheckbox", { entityId: props.row.entityId, checked: !props.isChecked });
}

// Ячейки комментария по колонкам этой строки: ячейку рисуем мы, а правку ведёт сама
// ячейка комментария, поэтому события с td передаём ей. При размонтировании Vue отдаёт
// null, по нему запись убираем, иначе в виртуальном списке останутся мёртвые ссылки.
const noteCells = new Map<string, any>();
function setNoteRef(colId: string, inst: any) {
  if (inst) noteCells.set(colId, inst);
  else noteCells.delete(colId);
}

// Событие уходит в ячейку комментария, только если попали в пустое место ячейки (цель
// это сама td) или внутрь блока комментария. Иначе в ячейке с несколькими подэлементами
// правку открывал бы и клик по постороннему содержимому, например по подзаголовку.
function noteCellFor(col: LiteColumn, ev: MouseEvent): any | null {
  const inst = noteCells.get(col.id);
  if (!inst) return null;
  const target = ev.target as HTMLElement | null;
  if (!target) return null;
  if (target === ev.currentTarget || target.closest(".qtl-note")) return inst;
  return null;
}

function onNoteCellMouseDown(col: LiteColumn, ev: MouseEvent) {
  noteCellFor(col, ev)?.handleCellMouseDown?.(ev);
}

function onCellClick(col: LiteColumn, ev: MouseEvent) {
  onMultieditCellClick(col);
  noteCellFor(col, ev)?.handleCellClick?.(ev);
}

function onEditPersonClick(ev: MouseEvent) {
  emit("updatePerson", { ev, entityId: props.row.entityId });
}

// Ячейка имени контакта: в выборке по контактам (canEditPerson уже проверяет
// DestType Person + права) это колонка с Category Name. По ней показываем карандаш
// правки человека.
function isPersonNameCell(col: LiteColumn): boolean {
  if (!canEditPerson) return false;
  const cell = props.row.cells[col.id];
  if (!cell || !cell.subItems) return false;
  return cell.subItems.some((s) => s.Category === ColumnCategory.Name);
}

function headerPartAt(text: string, idx: number): string {
  if (!text) return "";
  return text.split(",")[idx] || "";
}

// Имя тега (Category Name при DestType Tag) рисует TagNameCellElementLite: текст,
// кнопка правки в углу ЯЧЕЙКИ и инлайн-редактор. Признак держим в isHeavySimple, чтобы
// ячейка не ушла в обычный SimpleCellElementLite, и ловим её до CommonCellElementLite.
function isTagName(cell: TableDataCell): boolean {
  if (cell.DisplayType !== TableDataCellDisplayType.Simple && cell.DisplayType !== TableDataCellDisplayType.SimpleAsTag) {
    return false;
  }
  return (
    cell.Category === ColumnCategory.Name &&
    gstore.selectedItem?.DestType === AnalyticsV2ElementType.Tag
  );
}

// Артикул позиции и движения рисует VendorCodeCellElementLite: текст и кнопки info
// и клонирования. Признак держим в isHeavySimple.
function isVendorCode(cell: TableDataCell): boolean {
  if (cell.DisplayType !== TableDataCellDisplayType.Simple && cell.DisplayType !== TableDataCellDisplayType.SimpleAsTag) {
    return false;
  }
  return (
    cell.Category === ColumnCategory.ItemVendorCode ||
    cell.Category === ColumnCategory.MovementVendorCode
  );
}

// Комментарий позиции и движения склада рисует NotesCellElementLite: NativeInput и
// кнопки шаблонов и правки. Признак держим в isHeavySimple.
function isNote(cell: TableDataCell): boolean {
  if (cell.DisplayType !== TableDataCellDisplayType.Simple && cell.DisplayType !== TableDataCellDisplayType.SimpleAsTag) {
    return false;
  }
  const dest = gstore.selectedItem?.DestType;
  return (
    cell.Category === ColumnCategory.Details &&
    (dest === AnalyticsV2ElementType.StorageItem || dest === AnalyticsV2ElementType.StorageItemMovement)
  );
}

// Табличный комментарий рисуется той же ячейкой, что и складское инфо, но доступен
// в любом сегменте, поэтому проверка только по категории.
function isTableComment(cell: TableDataCell): boolean {
  if (cell.DisplayType !== TableDataCellDisplayType.Simple && cell.DisplayType !== TableDataCellDisplayType.SimpleAsTag) {
    return false;
  }
  return cell.Category === ColumnCategory.TableComments;
}

function isHeavySimple(cell: TableDataCell): boolean {
  if (cell.DisplayType !== TableDataCellDisplayType.Simple && cell.DisplayType !== TableDataCellDisplayType.SimpleAsTag) {
    return false;
  }
  const dest = gstore.selectedItem?.DestType;
  if (cell.Category === ColumnCategory.Name && dest === AnalyticsV2ElementType.Tag) return true;
  if (cell.Category === ColumnCategory.ItemVendorCode || cell.Category === ColumnCategory.MovementVendorCode) return true;
  if (cell.Category === ColumnCategory.Details &&
    (dest === AnalyticsV2ElementType.StorageItem || dest === AnalyticsV2ElementType.StorageItemMovement)) return true;
  if (cell.Category === ColumnCategory.TableComments) return true;
  return false;
}

// Свёрнутая ячейка (col.Minimized), кроме параметров и типа 16: к ним сворачивание
// не применяется. Контент оборачивается в MinimizedCellLite.
function isMinimized(cell: TableDataCell): boolean {
  return (
    !!(cell as any).Minimized &&
    cell.DisplayType !== TableDataCellDisplayType.Parameter &&
    cell.DisplayType !== TableDataCellDisplayType.DataOfStorageItem
  );
}

function iconHtml(cell: TableDataCell): string {
  return formatIconHtml(cell).join("<br/>");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
      return (_openBlock(), _createElementBlock("td", {
        key: col.id,
        "data-col-id": col.id,
        class: _normalizeClass(cellClass(col)),
        onMousedown: ($event: any) => (onNoteCellMouseDown(col, $event)),
        onClick: ($event: any) => (onCellClick(col, $event))
      }, [
        (col.isMultiedit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(MostaCheckbox, {
                class: "qtl-multi__check",
                "model-value": _ctx.isChecked,
                "onUpdate:modelValue": onToggleCheckbox,
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, null, 8, ["model-value"]),
              _createElementVNode("span", _hoisted_3, _toDisplayString((_ctx.rowNumberBase ?? 0) + _ctx.rowIndex + 1) + ".", 1),
              (isStoragePositions.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "qtl-multi__del",
                    disabled: !storageWA.value,
                    "aria-label": _ctx.$t('remove'),
                    onClick: _withModifiers(openDeleteConfirm, ["stop"])
                  }, _cache[10] || (_cache[10] = [
                    _createElementVNode("span", { class: "qtl-multi__del-ico" }, null, -1)
                  ]), 8, _hoisted_4))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.row.cells[col.id] && _ctx.row.cells[col.id].subItems.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.row.cells[col.id].subItems, (sub, subIdx) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: subIdx }, [
                    (_ctx.row.cells[col.id].subItems.length > 1 && sub.Data && sub.Data.length && headerPartAt(col.text, subIdx))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "qtl-sub-header",
                          innerHTML: headerPartAt(col.text, subIdx)
                        }, null, 8, _hoisted_5))
                      : _createCommentVNode("", true),
                    _createVNode(MinimizedCellLite, {
                      minimized: isMinimized(sub),
                      count: sub.Data ? sub.Data.length : 0
                    }, {
                      default: _withCtx(() => [
                        ((sub.DisplayType === 0 || sub.DisplayType === 6) && !isHeavySimple(sub))
                          ? (_openBlock(), _createBlock(SimpleCellElementLite, {
                              key: 0,
                              element: sub,
                              "entity-id": _ctx.row.cells[col.id].entityId,
                              "creator-id": _ctx.row.cells[col.id].creatorId,
                              onRefreshNeeded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('refreshNeeded')))
                            }, null, 8, ["element", "entity-id", "creator-id"]))
                          : (sub.DisplayType === 7)
                            ? (_openBlock(), _createBlock(ChangeDateCellElementLite, {
                                key: 1,
                                element: sub
                              }, null, 8, ["element"]))
                            : (sub.DisplayType === 12 || sub.DisplayType === 15)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 2,
                                  class: "qtl-icon-cell",
                                  innerHTML: iconHtml(sub)
                                }, null, 8, _hoisted_6))
                              : (sub.DisplayType === 18)
                                ? (_openBlock(), _createBlock(BillCellElementLite, {
                                    key: 3,
                                    element: sub
                                  }, null, 8, ["element"]))
                                : (sub.DisplayType === 16)
                                  ? (_openBlock(), _createBlock(CommonCellElementLite, {
                                      key: 4,
                                      element: sub,
                                      "src-element": _ctx.srcElement,
                                      "entity-id": _ctx.row.cells[col.id].entityId,
                                      "creator-id": _ctx.row.cells[col.id].creatorId,
                                      WA: _ctx.WA,
                                      "column-index": col.id + '_' + subIdx,
                                      "hovered-param-rec-id": hoveredParamRecId.value,
                                      "no-row-height-align": _ctx.row.cells[col.id].subItems.length > 1,
                                      onChangeHoverRecord: onCellHoverRecord,
                                      onChangeHeights: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('changeHeights', $event))),
                                      onRefreshNeeded: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('refreshNeeded'))),
                                      onSourceItemsRequested: ($event: any) => (_ctx.$emit('sourceItemsRequested', { ...$event, entityId: _ctx.row.cells[col.id].entityId }))
                                    }, null, 8, ["element", "src-element", "entity-id", "creator-id", "WA", "column-index", "hovered-param-rec-id", "no-row-height-align", "onSourceItemsRequested"]))
                                  : ([1, 3, 4, 8, 11, 13, 14, 17].includes(sub.DisplayType))
                                    ? (_openBlock(), _createBlock(EntityCellElementLite, {
                                        key: 5,
                                        element: sub
                                      }, null, 8, ["element"]))
                                    : (sub.DisplayType === 5 || sub.DisplayType === 9)
                                      ? (_openBlock(), _createBlock(JobCellElementLite, {
                                          key: 6,
                                          element: sub
                                        }, null, 8, ["element"]))
                                      : (sub.DisplayType === 10)
                                        ? (_openBlock(), _createBlock(TagCellElementLite, {
                                            key: 7,
                                            element: sub,
                                            "entity-id": _ctx.row.cells[col.id].entityId,
                                            onRefreshNeeded: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('refreshNeeded')))
                                          }, null, 8, ["element", "entity-id"]))
                                        : (sub.DisplayType === 19)
                                          ? (_openBlock(), _createBlock(SourceItemsCellElementLite, {
                                              key: 8,
                                              element: sub,
                                              onSourceItemsRequested: ($event: any) => (_ctx.$emit('sourceItemsRequested', { ...$event, entityId: _ctx.row.cells[col.id].entityId }))
                                            }, null, 8, ["element", "onSourceItemsRequested"]))
                                          : (sub.DisplayType === 2)
                                            ? (_openBlock(), _createBlock(ParameterCellElementLite, {
                                                key: 9,
                                                element: sub,
                                                "table-row-number": _ctx.row.cells[col.id].entityId,
                                                "column-index": col.id + '_' + subIdx,
                                                "hovered-param-rec-id": hoveredParamRecId.value,
                                                onChangeHoverRecord: onCellHoverRecord,
                                                onChangeHeights: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('changeHeights', $event)))
                                              }, null, 8, ["element", "table-row-number", "column-index", "hovered-param-rec-id"]))
                                            : (isTagName(sub))
                                              ? (_openBlock(), _createBlock(TagNameCellElementLite, {
                                                  key: 10,
                                                  element: sub,
                                                  "entity-id": _ctx.row.cells[col.id].entityId,
                                                  onRefreshNeeded: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('refreshNeeded')))
                                                }, null, 8, ["element", "entity-id"]))
                                              : (isVendorCode(sub))
                                                ? (_openBlock(), _createBlock(VendorCodeCellElementLite, {
                                                    key: 11,
                                                    element: sub,
                                                    "entity-id": _ctx.row.cells[col.id].entityId
                                                  }, null, 8, ["element", "entity-id"]))
                                                : (isNote(sub) || isTableComment(sub))
                                                  ? (_openBlock(), _createBlock(NotesCellElementLite, {
                                                      key: 12,
                                                      ref_for: true,
                                                      ref: (inst) => setNoteRef(col.id, inst),
                                                      element: sub,
                                                      "entity-id": _ctx.row.cells[col.id].entityId,
                                                      "creator-id": _ctx.row.cells[col.id].creatorId
                                                    }, null, 8, ["element", "entity-id", "creator-id"]))
                                                  : (_openBlock(), _createBlock(SimpleCellElementLite, {
                                                      key: 13,
                                                      element: sub,
                                                      "entity-id": _ctx.row.cells[col.id].entityId,
                                                      "creator-id": _ctx.row.cells[col.id].creatorId,
                                                      onRefreshNeeded: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('refreshNeeded')))
                                                    }, null, 8, ["element", "entity-id", "creator-id"]))
                      ]),
                      _: 2
                    }, 1032, ["minimized", "count"])
                  ], 64))
                }), 128)),
                (isPersonNameCell(col))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "qtl-person-edit-btn",
                      "aria-label": _ctx.$t('edit'),
                      onClick: _withModifiers(onEditPersonClick, ["stop"])
                    }, _cache[11] || (_cache[11] = [
                      _createElementVNode("svg", {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 16 16",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M14.9372 3.83936C15.1701 3.60633 15.1203 3.1787 14.8259 2.8843L13.1148 1.17324C12.8203 0.878802 12.3927 0.828861 12.1597 1.06191L10.7524 2.46913L13.5299 5.24659L14.9372 3.83936Z",
                          fill: "currentColor",
                          stroke: "currentColor",
                          "stroke-width": "0.390625"
                        }),
                        _createElementVNode("path", {
                          d: "M1.00066 15.195C1.64288 15.0543 3.58866 14.546 4.27003 14.3671C4.42665 14.3261 4.56959 14.2439 4.68397 14.1292L12.8352 5.97791L10.0576 3.20032L1.90638 11.3516C1.79163 11.4659 1.7096 11.6089 1.66846 11.7656C1.4895 12.4472 0.981335 14.3934 0.841554 15.0363C0.831666 15.0807 0.845216 15.1271 0.877441 15.1592C0.909666 15.1914 0.956223 15.2048 1.00066 15.195Z",
                          fill: "currentColor",
                          stroke: "currentColor",
                          "stroke-width": "0.390625"
                        })
                      ], -1)
                    ]), 8, _hoisted_7))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
      ], 42, _hoisted_1))
    }), 128)),
    (isStoragePositions.value)
      ? (_openBlock(), _createBlock(MostaContextMenu, {
          key: 0,
          visible: deleteConfirmOpen.value,
          position: deleteMenuPos.value,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (deleteConfirmOpen.value = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('sure_delete')), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  class: "qtl-del-confirm__btn",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (deleteConfirmOpen.value = false))
                }, _toDisplayString(_ctx.$t('cancel')), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "qtl-del-confirm__btn qtl-del-confirm__btn--accent",
                  onClick: confirmDelete
                }, _toDisplayString(_ctx.$t('remove')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible", "position"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})